export default "__VITE_ASSET__CBrV6O$___"